import { CgSpinnerTwo } from "react-icons/cg";

const Loading = ({ classNames, text }) => {
  return (
    <div
      className={`Loading d-flex flex-column align-items-center ${
        classNames || ``
      }`}
    >
      <div className="loading-spinner">
        <CgSpinnerTwo color="#fa6400" />
      </div>
      {text && <span className="text mt-3">{text}</span>}
    </div>
  );
};

export default Loading;
